<template>
    <div class="col-md-9">
        <div class="pages__title-holder mb-3">
            <h1 class="pages__title m-0">Teams</h1>
            <div class="d-flex align-items-center">
                <a href="/admin/panel/teams/create" class="btn btn_golden mr-1"><span>+ Add New</span></a>
            </div>
        </div>
        <div class="pages__table">
            <div class="pages__top">
                <div class="image">
                    Avatar
                </div>
                <div class="slug">
                    Name
                </div>
                <div class="route">
                    Position
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(member, index) in teams"
                    :key="member.id"
                >
                    <div class="image">
                        <img :src="getNameOfAvatar(member.avatar)" alt="photo">
                    </div>
                    <div class="slug">
                        {{ member.first_name}}  {{ member.last_name }}
                    </div>
                    <div class="route">
                       {{ member.position}}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a
                                :href="`/admin/panel/teams/${member.id}/edit`"
                                class="edit"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="openDeleteModal(member.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentMemberId)"
            @confirm="deleteMember(currentMemberId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this member?</p>
                    </div>
                </div>
            </template>
        </ActionModal>
    </div>
</template>


<script>
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";

export default {
    name: 'Teams',
    components: {ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            teams: [],
            currentMemberId: null,
        }
    },
    methods: {
        async fetchTeams() {
            try {
                const { data: response } = await AdminPanelService.fetchTeams()
                this.teams = response

            } catch (e) {
                console.error(e)
            }
        },
        openDeleteModal(id) {
            this.currentMemberId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async deleteMember(id) {
            try {
                await AdminPanelService.deleteMember(id)
                this.teams = this.teams.filter(member => member.id !== id)
                this.$showSuccessMessage('The member was deleted!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The member was not deleted. Please try again')
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
    },
    mounted() {
        this.fetchTeams()
    }
}

</script>


<style scoped>

</style>
